import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { OrganizationService } from '../../services/organization/organization.service';
import { PermissionService } from '../../services/permission/permission.service';
import { Permission } from '../../enums/permission.enum';
import { isSubscriptionActive } from '../../utils/is-subscription-active.util';
import { SUBSCRIPTION_LOCKED_ROUTE } from '../subscription/subscription.guard';

/**
 * Guards the plan-selection screen: only users who can manage billing belong
 * there (Checkout / plan changes are owner-or-admin territory on the backend
 * too). Members without the permission are routed to the locked screen when
 * the subscription is inactive, or back into the app when it is fine.
 */
export const billingAccessGuard: CanActivateFn = () => {
  const organizationService = inject(OrganizationService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  return organizationService.getCurrentOrganization().pipe(
    map((org) => {
      if (permissionService.canWithOrg(org, Permission.BillingsManage)) return true;
      return router.createUrlTree([isSubscriptionActive(org) ? '/' : SUBSCRIPTION_LOCKED_ROUTE]);
    }),
    // No organization context (e.g. no membership) - org creation explains it.
    catchError(() => of(router.createUrlTree(['/organizations/create']))),
  );
};
